import { debug, observer, pr, React, RouteComponentProps, theme, ui } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { ISigningResponse } from "types/signing";
import { AccountShort } from "../common/Account";
import { SigningComponent } from "../signing/views/SigningComponent";
import { LinkAccountStore } from "./LinkAccountStore";

type IProps = RouteComponentProps<{}> & {
    store: LinkAccountStore;
};

@observer
export class LinkAccountSigning extends React.Component<IProps, {}> {
    render() {
        const cardName = this.props.store.cardStore && this.props.store.cardStore.card ? this.props.store.cardStore.card.productI18N : "-";

        return (
            <SigningComponent
                signingInfo={this.props.store.response ? this.props.store.response.signInfo : undefined}
                content={
                    <div>
                        <pr.SigningLabelContainer>
                            <pr.SigningLabelTitle>{ui.__("loan.signing.product.title")}</pr.SigningLabelTitle>
                            <pr.SigningLabel>{cardName}</pr.SigningLabel>
                            <br />

                            <pr.SigningLabelTitle>{ui.__("linkAccount.document.title")}</pr.SigningLabelTitle>
                            {this.props.store.cardAccountsStore.linkedAccounts.length > 0 &&
                                <div>
                                    {this.props.store.cardAccountsStore.linkedAccounts.map(a => (
                                        <AccountShort key={a.id} style={{ marginBottom: theme.MARGIN }} account={a} />
                                    ))}
                                </div>
                            }
                            {this.props.store.cardAccountsStore.linkedAccounts.length === 0 &&
                                <pr.SigningLabel>{ui.__("common.none")}</pr.SigningLabel>
                            }
                        </pr.SigningLabelContainer>
                    </div>
                }

                onSuccess={(response: ISigningResponse) => {
                    debug.log("### signing success", response);
                    pushRoute("success");
                }}
                onRetry={async () => await this.props.store.linkAccounts()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/linkAccount/LinkAccountSigning.tsx